
import './LoaderProvider.scss'
import useLoader from "../../hooks/useLoader";
import useUrlParams from "../../hooks/useUrlParams";
import useScenario from "../../hooks/useScenario";
import { SCENARIO_DEPLOYMENT_TYPES } from "../../../simulate/constants";



const LoaderProvider = ({ children }: { children: React.ReactNode }) => {
    const { loading } = useLoader()
    const { dashboard } = useUrlParams()
    const { scenario } = useScenario()

    const deploymentType = scenario?.scenarioDeploymentType?.toUpperCase()
    const isValidateSummary = deploymentType === SCENARIO_DEPLOYMENT_TYPES.VALIDATE && dashboard === 'summary'

    // In Validate/Summary we don't want the global loader overlay to block clicks.
    // Console/other widgets manage their own internal loading/shimmer.
    const shouldBlockInteraction = loading && !isValidateSummary

    return (
        <main className={`command__center__loader__provider ${shouldBlockInteraction && 'loading'}`}>
            <div className="loader__container" />
            {children}
        </main>
    )
}

export default LoaderProvider